export enum MinOrMaxSide {
  Max = 'max',
  Min = 'min',
}

export enum DataRegion {
  NA = 'NA',
  EUR = 'EUR',
}

export const DATA_REGION_LABEL: Record<DataRegion, string> = {
  [DataRegion.NA]: 'North America',
  [DataRegion.EUR]: 'Europe',
};

export enum TempUnits {
  Fahrenheit = 'F',
  Celsius = 'C',
}

export enum ForecastSourceTypes {
  AG2 = 'AG2',
  ECMWF_AIFS_ENS = 'ECMWF_AIFS_ENS',
  ECMWF_AIFS_OP_0P25 = 'ECMWF_AIFS_OP_0P25',
  ECMWF_ENS = 'ECMWF_ENS',
  ECMWF_OP = 'ECMWF_OP',
  GFS_ENS = 'GFS_ENS',
  GFS_OP = 'GFS_OP',
}

export enum Parameters {
  MIN_TEMP = 'min',
  MAX_TEMP = 'max',
  AVG_TEMP = 'avg',
}

export enum TerraDrawMode {
  Static = 'static',
  Select = 'select',
  SelectReadonly = 'selectReadonly',
  Freehand = 'freehand',
}

export enum PolygonVisualState {
  Handle = 'handle',
  Base = 'base',
  Hover = 'hover',
  Selected = 'selected',
  Error = 'error',
  ErrorHover = 'errorHover',
  ErrorSelected = 'errorSelected',
  ManualEdit = 'manualEdit',
  Invisible = 'invisible',
}

export enum EditWarningActions {
  exitWithoutSaving = 'exitWithoutSaving',
  exitWithSaving = 'exitWithSaving',
  cancel = 'cancel',
}

export enum EditDialogSide {
  Left = 'left',
  Right = 'right',
}

export enum DuckDbColumnNames {
  IS_MAX_ERROR = 'is_max_error',
  IS_MIN_ERROR = 'is_min_error',
  EDITED_MIN_TEMP_VALUE_F = 'edited_min_temp_value_f',
  EDITED_MAX_TEMP_VALUE_F = 'edited_max_temp_value_f',
}

export enum ZOrderColumnNames {
  EditOrderMax = 'edit_order_max',
  EditOrderMin = 'edit_order_min',
}

export enum DailyPeriod {
  daily = 'daily',
  period = 'period',
}

export enum TableViewKey {
  DailyDay = 'daily-day',
  DailyParameter = 'daily-parameter',
  PeriodPeriod = 'period-period',
  PeriodParameter = 'period-parameter',
}

export enum LocalStorageKeys {
  defaultRegion = 'defaultRegion',
  dayOne = 'dayOne',
  isMenuExpanded = 'isMenuExpanded',
  mapSizes = 'mapSizes',
  brokenFeatures = 'brokenFeatures',
  terraDrawFeatures = 'terraDrawFeatures',
  mapConfigs = 'mapConfigs',
  headerSettings = 'headerSettings',
  activePage = 'activePage',
  params = 'params',
  manualEditConfiguration = 'manualEditConfiguration',
  tableNames = 'tableNames',
  weightedAnomalyContours = 'weightedAnomalyContours',
  weightingConfiguration = 'weightingConfiguration',
  forecastSources = 'forecastSources',
  importedSources = 'importedSources',
  selectedBaselineIsImported = 'selectedBaselineIsImported',
  editConfigurationWithValues = 'editConfigurationWithValues',
  weightingConfigurationWithValues = 'weightingConfigurationWithValues',
  lastCustomKeysClearDate = 'lastCustomKeysClearDate',
  graphicsSettings = 'graphicsSettings',
  selectedSubRegionFilter = 'selectedSubRegionFilter',
  selectedCustomFilterId = 'selectedCustomFilterId',
  selectedTableSort = 'selectedTableSort',
  copyWeightingsSelections = 'copyWeightingsSelections',
  openSourceDialogAfterReset = 'openSourceDialogAfterReset',
  forecastMode = 'forecastMode',
  subseasonalView = 'subseasonalView',
}

export enum PeriodValues {
  '1-5day' = '1-5day',
  '6-10day' = '6-10day',
  '11-15day' = '11-15day',
  //'businessWeek' = 'businessWeek',
  '1-7day' = '1-7day',
  '8-14day' = '8-14day',
}

export enum ForecastMode {
  ShortRange = 'shortRange',
  Subseasonal = 'subseasonal',
}

export enum SubseasonalView {
  Daily = 'daily',
  Weekly = 'weekly',
  Period = 'period',
}

export enum SubseasonalPeriod {
  WEEK_3 = 'week-3',
  WEEK_4 = 'week-4',
  WEEK_5 = 'week-5',
  WEEK_6 = 'week-6',
  WEEK_3_4 = 'week-3-4',
  WEEK_5_6 = 'week-5-6',
  WEEK_3_TO_6 = 'week-3-6',
  DAY_16_20 = 'day-16-20',
}

export enum DailyHouly {
  daily = 'daily',
  hourly = 'hourly',
}

export enum ErrorIconIds {
  daily = 'no-data-daily',
  period = 'no-data-period',
}

export enum MainMapInputs {
  mapHeightChanged = 'mapHeightChanged',
  selectedProperty = 'selectedProperty',
  tempUnit = 'tempUnit',
  isDfn = 'isDfn',
}

export enum ToastType {
  Success = 'success',
  Error = 'error',
}

export enum ToastOutlet {
  Global = 'global',
  MainMap = 'main-map',
}

export enum FileExtension {
  Csv = 'csv',
  Xlsx = 'xlsx',
  Xls = 'xls',
}
